/** ----------------~ S I N G L E  P A N E L  ~----------------- */

/**
 * Initializes a new single panel field component.
 *
 * @param {element} The component's root element.
 * @copyright Copyright (c) 2013 Nationale Nederlanden
 */

nn.component.SinglePanel = function(element) {
  this.element = $(element);
  this.init();
};

$.extend(nn.component.SinglePanel.prototype, {
  init: function() {
    this.getAndSetElements();
    this.getElementData();
    this.bindEvents();

    if (this.checkbox[0].checked) {
      this.activate();
      this.open();

      // Make sure animations are added after initial activation
      this.element.addClass('single-panel--animated');
    } else {
      this.deactivate();

      // Make sure animations are added after initial activation
      this.contentContainer.one(
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        $.proxy(function() {
          this.element.addClass('single-panel--animated');
        }, this)
      );
    }
  },
  getAndSetElements: function() {
    this.contentElement = $('.single-panel-content', this.element);
    this.contentContainer = $('.single-panel-content-container', this.element);
    this.checkbox = $('.single-panel-check', this.element);
    this.toggle = $('.single-panel-toggle', this.element);
  },
  getElementData: function() {
    this.contentHeight = this.contentElement.outerHeight();
  },
  updateHeight: function() {
    if (this.isActive()) {
      this.getElementData();
      this.setContentHeight(this.contentHeight + 'px');
    }
  },
  bindEvents: function() {
    if (MutationObserver) {
      new MutationObserver(this.updateHeight.bind(this)).observe(
        this.contentElement[0],
        {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        }
      );
    }

    this.checkbox.on('change', $.proxy(this.toggleActive, this));
    this.toggle.on('click', $.proxy(this.toggleOpen, this));
  },
  isOpen: function() {
    return !this.element.hasClass('single-panel--closed');
  },
  open: function() {
    this.setContentHeight(this.contentHeight + 'px');
    this.element.removeClass('single-panel--closed');
  },
  close: function() {
    if (this.isOpen()) {
      this.contentHeight = this.contentElement.outerHeight();
      this.setContentHeight('0px');
      this.element.addClass('single-panel--closed');
    }
  },
  setContentHeight: function(height) {
    if (height.match(/^[0-9]+$/)) {
      height += 'px';
    }
    if (!this.isAnimated()) {
      this.contentContainer.css({ height: height });
    } else {
      this.contentContainer.stop().animate({ height: height }, 500);
    }
  },
  toggleOpen: function() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  },
  isActive: function() {
    return this.element.hasClass('is-active');
  },
  activate: function() {
    if (!this.isOpen()) {
      this.open();
    }
    this.element.addClass('is-active');
  },
  deactivate: function() {
    if (this.isOpen()) {
      this.close();
    }
    this.element.removeClass('is-active');
  },
  toggleActive: function() {
    if (!this.isActive() || !this.checkbox[0].checked) {
      this.deactivate();
    } else if (this.checkbox[0].checked) {
      this.activate();
    }
  },
  isAnimated: function() {
    return this.element.hasClass('single-panel--animated');
  }
});
